import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import Slider from "react-slick";
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';

export default function BlogDetailCards({ initialData }) {


    const { slug } = useParams();
    const [recentData, setRecentData] = useState(initialData || []);
    const navigate = useNavigate(); // ✅ add this

    const fetchRecent = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/blogs`, { method: "GET" });
            const result = await response.json();

            if (result.blogs === false) {
                throw new Error(`API error: ${result.message}`);
            }
            const currentBlog = result.blogs.find(item => item.slug === slug);

            if (!currentBlog) {
                navigate("/404", { replace: true });
                return;
            }
            const latestBlogs = result.blogs.filter((item) => (item.slug !== slug))?.slice(-3);;
            setRecentData(latestBlogs);
        } catch (error) {
            console.error("Fetch error:", error.message);
            navigate("/404", { replace: true });
        }
    };

    useEffect(() => {
        fetchRecent();
    }, [slug]);


    if (!recentData.length) return null;

    const settingskey = {
        autoplay: true,
        speed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: (
            <button className="slick-arrow slick-prev" aria-label="Previous Slide">
                <i className="fa-solid fa-arrow-left"></i>
            </button>
        ),

        nextArrow: (
            <button className="slick-arrow slick-next" aria-label="Next Slide">
                <i className="fa-solid fa-arrow-right"></i>
            </button>
        ),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                },
            },

            {
                breakpoint: 99999,
                settings: "unslick",
            },
        ],
    };
    return (
        <>
            <section className="blogpage recent-post">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="related-text center-heading">
                                <h3 className="heading">You might also like</h3>
                            </div>
                        </div>
                    </div>
                    <div className="other-projects-wrap">
                        <Slider {...settingskey} className="other-detail-slides">
                            {recentData.map((item, index) => (
                                <div className="other-detail-card" key={index}>
                                    <Link to={`/blog/${item.slug}/`} className="blogpost-box">
                                        <div className='blogpost-image'>
                                            <img src={item?.thumbnail ? `${BaseUrl}${item.thumbnail}` : undefined} className="img-responsive" alt={item?.alt_thumbnail} loading="lazy" />
                                            <span>{DateConvert(item?.date)}5</span>
                                        </div>
                                        <div className='blogpost-detail'>
                                            <span>{item?.title?.slice(0, 40) + "..."}</span>
                                            <p>{item?.brief?.slice(0, 75) + "..."}</p>
                                            <div className='arrow-butn'>Learn More <img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" /></div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </Slider>
                        <div className="col-lg-12">
                            <div className='text-center'>
                                <Link to={"/blog"} className="default-btn"><span>View More</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}



